<template>
    <div class="card-list">
        <div class="hd">
            <div class="ht">
                <h2>更多新闻</h2>
            </div>
            <div class="hc">
                <div class="cl-box">
                <div class="cl-box__item" :key="post.id" v-for="post in posts">
                    <div class="cl-box__image">
                        <img :src="post.thumb_image" :alt="post.title.rendered" />
                    </div>
                    <div class="cl-box__title">
                        <router-link :to="{ name: 'NewsDetail', params: { contentId: post.id }}">{{post.title.rendered}}</router-link>
                    </div>
                    <div class="cl-box__desc" v-html="post.excerpt.rendered"></div>
                    <div class="cl-box__date">{{ post.date | formatDate("yyyy-MM-dd") }}</div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apiWpV2 from "@/api/wp";

export default {
    name: "card-list",
    props: {
        // 暂无用
        excludePostIds: Array,
        dateCategory: Array
    },
    data() {
        return {
            posts: [
                {
                    id: 4039,
                    date: "2021-05-15T06:00:44",
                    date_gmt: "2021-05-15T06:00:44",
                    guid: {
                        rendered: "https://www.xiongsu.cn/?p=4039",
                    },
                    modified: "2021-05-19T06:15:40",
                    modified_gmt: "2021-05-19T06:15:40",
                    slug: "%e7%ac%ac%e4%b8%89%e5%b1%8a5-15%e5%85%a8%e5%9b%bd%e6%8a%95%e8%b5%84%e8%80%85%e4%bf%9d%e6%8a%a4%e5%ae%a3%e4%bc%a0%e6%97%a5",
                    status: "publish",
                    type: "post",
                    link: "https://www.xiongsu.cn/2021/05/15/%e7%ac%ac%e4%b8%89%e5%b1%8a5-15%e5%85%a8%e5%9b%bd%e6%8a%95%e8%b5%84%e8%80%85%e4%bf%9d%e6%8a%a4%e5%ae%a3%e4%bc%a0%e6%97%a5/",
                    title: {
                        rendered: "第三届“5.15全国投资者保护宣传日”",
                    },
                    content: {
                        rendered:
                            '<p><img loading="lazy" class="size-large wp-image-4043 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-1024x436.jpg" alt="" width="1024" height="436" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-1024x436.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-300x128.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-768x327.jpg 768w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222.jpg 1080w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>为维护中小投资者合法权益，保障资本市场持续健康发展，积极响应中国证券监督管理委员会“第三届5.15全国投资者保护宣传日”的号召，广东雄塑科技集团股份有限公司提醒您，对各类“股市黑嘴”、“非法荐股”、“场外配资”提高防范意识，避免侥幸心理、谨防诈骗，不轻信免费荐股电话、短信、微信、直播等，自觉远离违法活动，保护好自己的财产安全。</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4040 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/1-1024x512.jpg" alt="" width="1024" height="512" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/1-1024x512.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/1-300x150.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/1-768x384.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4041 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/2-1024x512.jpg" alt="" width="1024" height="512" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/2-1024x512.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2-300x150.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2-768x384.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4042 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-1024x1024.jpg" alt="" width="1024" height="1024" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-1024x1024.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-150x150.jpg 150w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-300x300.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-768x768.jpg 768w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-250x250.jpg 250w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-86x86.jpg 86w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-427x427.jpg 427w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-120x120.jpg 120w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-31x31.jpg 31w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-95x95.jpg 95w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-270x270.jpg 270w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-370x370.jpg 370w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-72x72.jpg 72w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>中国投资者网（www.investor.org.cn）是中国证监会管理的公益网络服务平台，为投资者提供知识普及、权益维护、互动交流等信息和服务。中国投资者网，投资者自己的网站！更多咨询速递、知识普及、投资者互动、维权敬请关注中国投资者网！</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-full wp-image-4045 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/图片2.png" alt="" width="149" height="187" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-full wp-image-4044 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/图片1.png" alt="" width="130" height="177" /></p>\n',
                        protected: false,
                    },
                    excerpt: {
                        rendered:
                            "<p>2018年11月19日上午，南海区九江镇为了进一步落实乡村振兴战略，推动乡村旅游发展，推进美丽文明村居建设，依托璜矶鹭鸟天堂为背景舞台，以风景美丽的百足桥为T台，联同区书法协会、美术协会进行现场挥毫创作，同时联合南海区医用卫用行业协会进行无纺布时装及用品展示，继而举办的企业及团体展示产品或展示自我创意的鹭鸟天堂旗袍时装T台秀活动圆满落幕。</p>\n",
                        protected: false,
                    },
                    author: 1,
                    featured_media: 4049,
                    comment_status: "open",
                    ping_status: "open",
                    sticky: false,
                    template: "",
                    format: "standard",
                    meta: [],
                    categories: [3],
                    tags: [],
                    thumb_image:
                        "https://www.xiongsu.cn/wp-content/uploads/2021/05/375X210-2.jpg",
                    acf: false,
                    _links: {
                        self: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039",
                            },
                        ],
                        collection: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts",
                            },
                        ],
                        about: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/types/post",
                            },
                        ],
                        author: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/users/1",
                            },
                        ],
                        replies: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/comments?post=4039",
                            },
                        ],
                        "version-history": [
                            {
                                count: 2,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039/revisions",
                            },
                        ],
                        "predecessor-version": [
                            {
                                id: 4050,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039/revisions/4050",
                            },
                        ],
                        "wp:featuredmedia": [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media/4049",
                            },
                        ],
                        "wp:attachment": [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media?parent=4039",
                            },
                        ],
                        "wp:term": [
                            {
                                taxonomy: "category",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/categories?post=4039",
                            },
                            {
                                taxonomy: "post_tag",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/tags?post=4039",
                            },
                        ],
                        curies: [
                            {
                                name: "wp",
                                href: "https://api.w.org/{rel}",
                                templated: true,
                            },
                        ],
                    },
                },
                {
                    id: 3909,
                    date: "2020-12-29T03:02:45",
                    date_gmt: "2020-12-29T03:02:45",
                    guid: {
                        rendered: "https://www.xiongsu.cn/?p=3909",
                    },
                    modified: "2021-01-07T03:14:36",
                    modified_gmt: "2021-01-07T03:14:36",
                    slug: "%e9%9b%84%e5%a1%91%e9%9b%86%e5%9b%a22021%e5%b9%b4%e5%85%83%e6%97%a6%e6%99%9a%e4%bc%9a%e6%9a%a82020%e5%b9%b4%e5%ba%a6%e5%85%88%e8%bf%9b%e8%a1%a8%e5%bd%b0%e5%a4%a7%e4%bc%9a%e8%83%9c%e5%88%a9%e5%8f%ac",
                    status: "publish",
                    type: "post",
                    link: "https://www.xiongsu.cn/2020/12/29/%e9%9b%84%e5%a1%91%e9%9b%86%e5%9b%a22021%e5%b9%b4%e5%85%83%e6%97%a6%e6%99%9a%e4%bc%9a%e6%9a%a82020%e5%b9%b4%e5%ba%a6%e5%85%88%e8%bf%9b%e8%a1%a8%e5%bd%b0%e5%a4%a7%e4%bc%9a%e8%83%9c%e5%88%a9%e5%8f%ac/",
                    title: {
                        rendered:
                            "雄塑集团2021年元旦晚会暨2020年度先进表彰大会胜利召开",
                    },
                    content: {
                        rendered:
                            '<p><img loading="lazy" class="size-large wp-image-3921 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/合影-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/合影-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/合影-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/合影-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>12月29日晚，雄塑集团公司与广东基地2021年元旦晚会暨2020年度先进表彰大会在集团公司总部隆重举行，公司董事会、管理团队及全体员工与会，大家欢聚一堂，载歌载舞，喜迎新年，共同展望2021年的美好愿景！</p>\n<p>本次大会含表彰及元旦晚会两个环节。表彰大会于19：15开始，董事、股东代表黄铭雄先生代表董事会及管理团队致辞，对到会的全体人员表示热烈欢迎和诚挚问候，对仍奋战在工作岗位的同事表示由衷敬意！黄总高度赞扬了员工在年初抗击新冠疫情及复工复产方面的突出表现，充分肯定了公司2020年度整体经营业绩及各方面的进步。面对更不确定的2021年，其勉励全体雄塑人团结一心，攻坚克难，迎接新挑战，再创新业绩！</p>\n<p><img loading="lazy" class="size-large wp-image-3910 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/IMG_1958-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/IMG_1958-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/IMG_1958-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/IMG_1958-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3923 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/三八红旗手-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/三八红旗手-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/三八红旗手-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/三八红旗手-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3922 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/集团十佳-1024x682.jpg" alt="" width="1024" height="682" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/集团十佳-1024x682.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/集团十佳-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/集团十佳-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3929 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀管理奖-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀管理奖-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀管理奖-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀管理奖-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3930 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀团队-1024x682.jpg" alt="" width="1024" height="682" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀团队-1024x682.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀团队-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀团队-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3928 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀党员-1024x679.jpg" alt="" width="1024" height="679" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀党员-1024x679.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀党员-300x199.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀党员-768x510.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3931 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀新人奖-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀新人奖-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀新人奖-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀新人奖-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3933 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀员工-1024x682.jpg" alt="" width="1024" height="682" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀员工-1024x682.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀员工-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀员工-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3927 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀班组长-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀班组长-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀班组长-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/优秀班组长-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3920 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/合理化建议-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/合理化建议-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/合理化建议-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/合理化建议-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>集团公司总经理彭晓伟等领导对荣获2020年度集团十佳、优秀党员、优秀员工、优秀管理奖、优秀班组长奖、优秀团队等一批先进集体及个人进行了表彰，研发工程师杜顺钊代表受表彰的先进单位及个人作了精彩发言，员工们深受鼓舞！</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-3926 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/雄心塑造-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/雄心塑造-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/雄心塑造-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/雄心塑造-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3925 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/少年3-1024x682.jpg" alt="" width="1024" height="682" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/少年3-1024x682.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/少年3-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/少年3-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3914 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/抽奖-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/抽奖-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/抽奖-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/抽奖-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3913 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/01/财务跳舞-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/01/财务跳舞-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/01/财务跳舞-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/01/财务跳舞-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>元旦晚会于20：20开始，很多是我们雄塑员工自创的节目，包括：党支部提供的合唱《雄心塑造》、质量管理部提供的小品《安全生产大于天》、财务管理中心提供的精美舞蹈《笑纳》以及商务大楼提供的歌舞《少年》，一次次将晚会气氛推向高潮。为了进一步活跃现场气氛，期间还安排了丰富多彩的抽奖环节。</p>\n<p>晚会于21：30顺利落下帷幕，本次大会由集团公司党支部和工会主办，人力资源中心等有关部门协办，会议的成功举办，丰富了员工的文化生活，加强了员工间的交流，提振了员工的信心。</p>\n<p>即将到来的2021年，在董事会的坚强领导下，我们将继续砥砺前行，乘风破浪，再创辉煌！</p>\n<p>&nbsp;</p>\n',
                        protected: false,
                    },
                    excerpt: {
                        rendered:
                            "<p>2018年11月19日上午，南海区九江镇为了进一步落实乡村振兴战略，推动乡村旅游发展，推进美丽文明村居建设，依托璜矶鹭鸟天堂为背景舞台，以风景美丽的百足桥为T台，联同区书法协会、美术协会进行现场挥毫创作，同时联合南海区医用卫用行业协会进行无纺布时装及用品展示，继而举办的企业及团体展示产品或展示自我创意的鹭鸟天堂旗袍时装T台秀活动圆满落幕。</p>\n",
                        protected: false,
                    },
                    author: 1,
                    featured_media: 3935,
                    comment_status: "open",
                    ping_status: "open",
                    sticky: false,
                    template: "",
                    format: "standard",
                    meta: [],
                    categories: [3],
                    tags: [],
                    thumb_image:
                        "https://www.xiongsu.cn/wp-content/uploads/2021/01/合影375X210.jpg",
                    acf: false,
                    _links: {
                        self: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3909",
                            },
                        ],
                        collection: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts",
                            },
                        ],
                        about: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/types/post",
                            },
                        ],
                        author: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/users/1",
                            },
                        ],
                        replies: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/comments?post=3909",
                            },
                        ],
                        "version-history": [
                            {
                                count: 1,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3909/revisions",
                            },
                        ],
                        "predecessor-version": [
                            {
                                id: 3936,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3909/revisions/3936",
                            },
                        ],
                        "wp:featuredmedia": [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media/3935",
                            },
                        ],
                        "wp:attachment": [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media?parent=3909",
                            },
                        ],
                        "wp:term": [
                            {
                                taxonomy: "category",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/categories?post=3909",
                            },
                            {
                                taxonomy: "post_tag",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/tags?post=3909",
                            },
                        ],
                        curies: [
                            {
                                name: "wp",
                                href: "https://api.w.org/{rel}",
                                templated: true,
                            },
                        ],
                    },
                },
                {
                    id: 3878,
                    date: "2020-11-06T05:50:04",
                    date_gmt: "2020-11-06T05:50:04",
                    guid: {
                        rendered: "https://www.xiongsu.cn/?p=3878",
                    },
                    modified: "2020-11-19T06:13:10",
                    modified_gmt: "2020-11-19T06:13:10",
                    slug: "%e3%80%90%e9%9b%84%e5%a1%91%e7%a7%91%e6%8a%80%e3%80%91%e6%88%90%e5%8a%9f%e4%b8%be%e5%8a%9e%e7%ac%ac%e5%8d%81%e4%ba%94%e5%b1%8a%e8%81%8c%e5%b7%a5%e8%bf%90%e5%8a%a8%e4%bc%9a",
                    status: "publish",
                    type: "post",
                    link: "https://www.xiongsu.cn/2020/11/06/%e3%80%90%e9%9b%84%e5%a1%91%e7%a7%91%e6%8a%80%e3%80%91%e6%88%90%e5%8a%9f%e4%b8%be%e5%8a%9e%e7%ac%ac%e5%8d%81%e4%ba%94%e5%b1%8a%e8%81%8c%e5%b7%a5%e8%bf%90%e5%8a%a8%e4%bc%9a/",
                    title: {
                        rendered: "【雄塑科技】成功举办第十五届职工运动会",
                    },
                    content: {
                        rendered:
                            '<section></section>\n<section></section>\n<section></section>\n<section></section>\n<section>       为了加强企业内部凝聚力、增加同事之间的工作友谊，丰富员工的业余生活，2020年11月6日，广东雄塑科技集团股份有限公司在员工体育活动中心隆重举行雄塑集团第十五届职工运动会。</section>\n<p>       九江镇总工会副主席卢坚祥、干事黄子伟、集团公司董事长黄淦雄、总经理彭晓伟、党支部书记黄铭雄及各有关部门负责人参加了运动会开、闭幕式。运动会现场气氛热闹非凡。</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-3880 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0307-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0307-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0307-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0307-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">       本次职工运动会涵盖五大运动项目（团队趣味运动比赛、男女子混合拔河比赛、男子篮球、羽毛球个人赛、乒乓球个人赛），共有26支代表队参加比赛，参赛职工达430人；从集团领导到中基层管理人员，再到生产一线工人，共一百多名职工参与到运动会的前期筹备、啦啦队组织以及后勤保障中来，为运动会的成功举办做出了积极贡献。赛场上，运动健儿们激情飞扬、奋力拼搏，最终比拼出了团体奖项17个和个人奖项24个；公司对胜出的个人及代表队分别颁发了奖杯、奖金及荣誉证书。</p>\n<p><img loading="lazy" class="size-large wp-image-3882 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0401-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0401-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0401-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0401-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /> <img loading="lazy" class="size-large wp-image-3884 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0552-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0552-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0552-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0552-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3883 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0463-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0463-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0463-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0463-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3887 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0929-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0929-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0929-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0929-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3892 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0972-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0972-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0972-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0972-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">       为了充分发扬雄塑集团“团结、拼搏、开放、包容”的企业文化，本届运动会新增了男子篮球友谊赛项目，邀请了供应商代表：安润物流、新力达物流联盟、华南聚塑汇与我们男子篮球冠、亚军代表队进行了一场非常精彩的篮球赛事，为本届运动会增添了一道亮丽的风景线。</p>\n<p><img loading="lazy" class="size-large wp-image-3885 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0657-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0657-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0657-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0657-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /> <img loading="lazy" class="size-large wp-image-3886 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0821-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0821-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0821-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0821-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3890 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0623-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0623-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0623-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0623-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3888 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0988-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0988-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0988-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0988-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3891 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0838-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0838-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0838-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_0838-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><img loading="lazy" class="size-large wp-image-3889 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_1037-1024x683.jpg" alt="" width="1024" height="683" srcset="https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_1037-1024x683.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_1037-300x200.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2020/11/IMG_1037-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: justify;">       在本次运动会中，本着“友谊第一，比赛第二”的理念，各位参赛选手积极投身比赛，赛出了风格，赛出了水平。充分展现了雄塑集团全体同仁对体育运动的热情，不仅锻炼了身体素质，而且磨练了精神意志，增强了大家的团队合作精神和集体荣誉感。</p>\n',
                        protected: false,
                    },
                    excerpt: {
                        rendered:
                            "<p>2018年11月19日上午，南海区九江镇为了进一步落实乡村振兴战略，推动乡村旅游发展，推进美丽文明村居建设，依托璜矶鹭鸟天堂为背景舞台，以风景美丽的百足桥为T台，联同区书法协会、美术协会进行现场挥毫创作，同时联合南海区医用卫用行业协会进行无纺布时装及用品展示，继而举办的企业及团体展示产品或展示自我创意的鹭鸟天堂旗袍时装T台秀活动圆满落幕。</p>\n",
                        protected: false,
                    },
                    author: 1,
                    featured_media: 3895,
                    comment_status: "open",
                    ping_status: "open",
                    sticky: false,
                    template: "",
                    format: "standard",
                    meta: [],
                    categories: [3],
                    tags: [],
                    thumb_image:
                        "https://www.xiongsu.cn/wp-content/uploads/2020/11/375x210-1.jpg",
                    acf: false,
                    _links: {
                        self: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3878",
                            },
                        ],
                        collection: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts",
                            },
                        ],
                        about: [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/types/post",
                            },
                        ],
                        author: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/users/1",
                            },
                        ],
                        replies: [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/comments?post=3878",
                            },
                        ],
                        "version-history": [
                            {
                                count: 8,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3878/revisions",
                            },
                        ],
                        "predecessor-version": [
                            {
                                id: 3903,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/3878/revisions/3903",
                            },
                        ],
                        "wp:featuredmedia": [
                            {
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media/3895",
                            },
                        ],
                        "wp:attachment": [
                            {
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/media?parent=3878",
                            },
                        ],
                        "wp:term": [
                            {
                                taxonomy: "category",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/categories?post=3878",
                            },
                            {
                                taxonomy: "post_tag",
                                embeddable: true,
                                href: "https://www.xiongsu.cn/wp-json/wp/v2/tags?post=3878",
                            },
                        ],
                        curies: [
                            {
                                name: "wp",
                                href: "https://api.w.org/{rel}",
                                templated: true,
                            },
                        ],
                    },
                },
            ],
            contentId: 0
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        $route(to, from) {
            // 监听路由是否变化
            // console.info(to)
            if (to.params.contentId !== from.params.contentId) {
                // set default
                // this.articles = []
                // this.paging = []
                this.init(); // 重新加载数据
            }
        },
    },
    methods: {
        init() {
            this.getRandomPosts();
        },
        async getRandomPosts() {
            let self = this;

            let posts = await apiWpV2.getPosts({
                categories: self.dateCategory,
                exclude: [self.$route.params.contentId],
                per_page: 3
            })
            // console.info(posts.data);
            this.posts = posts.data;
        },
    }
};
</script>
<style lang="scss">
    .card-list {
        padding-top: 40px;
        padding-bottom: 40px;

        .ht {
            h2 {
                font-size: 20px;
            }
            padding-bottom: 20px;
        }
    }
    .cl-box {
        display: flex;
        justify-content: space-between;
        color: #333;

        &__title {
            font-size: 16px;
            font-weight: bold;
            padding: 20px 0 10px;
        }

        &__item {
            width: 440px;
        }

        &__desc {
            font-size: 14px;
            padding-bottom: 10px;
        }

        &__date {
            font-size: 14px;
            color: #999;
        }

        &__image {
            img {
                display: block;
                width: 100%;
            }
        }
    }

    .mobile {
        .card-list {
            .ht {
                h2 {
                    font-size: 14px;
                }
                padding-bottom: 5vw;
            }
        }
        .cl-box {
            width: 90vw;
            margin: 0 auto;
            display: block;
            &__item {
                display: flex;
                flex-wrap: wrap;
                padding-bottom: 5vw;
                width: 100%;
            }
            &__image {
                order: 1;
            }
            &__title {
                width: 90vw;
                order: 2;
                padding-top: 3vw;
                padding-bottom: 2vw;
                font-size: 14px;
            }
            &__date {
                width: 90vw;
                order: 3;
                padding-bottom: 3vw;
                font-size: 12px;
            }
            &__desc {
                width: 90vw;
                order: 4;
                font-size: 12px;
            }
        }
    }
</style>
